import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from '../../../../shared/common.service';
import { PostBalanceSheetEventsService } from './post-balance-sheet-events.service';
import * as CryptoJS from 'crypto-js';
import Swal from 'sweetalert2';
import { Observable } from 'rxjs';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';

@Component({
  selector: 'app-post-balance-sheet-events',
  templateUrl: './post-balance-sheet-events.component.html',
  styleUrls: ['./post-balance-sheet-events.component.scss']
})
export class PostBalanceSheetEventsComponent implements OnInit {
  APPeriodId: any;;
  posteventform: FormGroup;
  isJump: any;
  NormalRoutng: boolean;
  showBubbledata:any
  constructor(private Formbuilder: FormBuilder, public commonService: CommonService, private router: Router, public postbalancesheet: PostBalanceSheetEventsService, public formbuilder: FormBuilder, public sidenav: SideNavService) {
  }
  ngOnInit() {
      debugger
      this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
      this.commonService.getIncomeStatementsHeaders();
    this.getpostevents(this.APPeriodId)
    this.createpostevents();
    this.clearfield();
    this.commonService.getNotesData();
    //this.commonService.Showbubble.subscribe((data) => {
      //if (data) {
        this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)).subscribe((data) => {
          this.commonService.showBubble = data[0].ImportStatus
          if (this.commonService.showBubble) {
            this.sidenav.setShowBubble(true);
            this.getlastyeardata()
          }
        })
     // }
      //else {
      //  this.showBubbledata = null
      //}
   // })
    if (localStorage.getItem("SubmitStatus") == "true")
      this.posteventform.disable()
    this.isJump = localStorage.getItem('isJump');
  }

  createpostevents() {
    this.posteventform = this.formbuilder.group({
      APPeriodId: ['', []],
      PostBalanceSheetEventsId: ['', []],
      PostBalanceSheetEventsTextComment: ['', []],
      CreatedBy: ['', []]
    })
  }

  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        this.posteventform.reset()
      }
    })
  }

  insert() {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.posteventform.controls['APPeriodId'].setValue(this.APPeriodId);
    this.posteventform.controls['CreatedBy'].setValue(localStorage.getItem('LoginuserId'));
    const formdata = this.posteventform.getRawValue();
    this.postbalancesheet.insertpostbalancesheet(formdata).subscribe((data) => {
      this.posteventform.markAsPristine();
      if (this.NormalRoutng)
        return true;
      var nextPage;
      nextPage = this.commonService.getNextNoteSelection("Post balance sheet events", this.commonService.NotesList)
      if (this.isJump == 'true')
        this.router.navigate(['/notes'])
      else if (nextPage == 'postbalancesheetevents') {
        nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
        this.router.navigate([nextPage]);
      }
      else {
        this.router.navigate([nextPage]);
      }
    })
  }

  getpostevents(APPeriodId) {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.postbalancesheet.Getpostbalancesheet(APPeriodId).subscribe((data: any) => {
      this.posteventform.patchValue(data)
    })
   // this.commonService.getNotesData();
  }
  getlastyeardata() {
    this.postbalancesheet.GetpostbalancesheetLY(this.APPeriodId).subscribe((data: any) => {
      this.showBubbledata = data;
    })
  }

  back() {
    debugger
    this.posteventform.markAsPristine();
    var backpage;
    backpage = this.commonService.getBackSelection("Post balance sheet events", this.commonService.NotesList)
    if (this.isJump == 'true')
      this.router.navigate(['/notes'])
    else if (backpage == 'Post balance sheet events')
      this.router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Post balance sheet events", this.commonService.NotesList)
      this.router.navigate([backpage]);
    }
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.posteventform.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight: 900'>You have unsaved data. </span><br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.NormalRoutng = true;
          this.insert();
          return true;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.router.navigate(['/business']);

  }
}
